import React from 'react';
import {formatDate} from '../helpers/util';
import utdannelse from "../img/opdraetterlogo.png";
import masterclass from "../img/masterclass_100.png";
import xregister from "../img/xregister.png";
import mental from "../img/mental.png";
import avlsanbefaling from "../img/avlsanbefaling.png";
import importert from "../img/import.png";
import HundMetadata from '../components/HundMetadata'
import icons from "../helpers/icons";
import Bilde from "./Bilde";
import Uploadable from './Uploadable';
import {postForm} from '../api';





const Hund = ({hund, profilBilde, personId, favoritt, updateFavorittStatus, reloadBilde}) => {

    function slettHundBilde() {
        const formdata = new FormData();
        formdata.append('hundId', hund.hundId);
        postForm("slettHundProfilBilde", formdata)
            .then((data) => {
                reloadBilde();
            })
            .catch((err) => {
                console.log(err);
            });
    }

    function appendFormData(formdata) {
        formdata.append('hundId', hund.hundId);
    }

    const showUploadIcon = () => {
        if (profilBilde === null &&
            personId !== null &&
            hund !== null &&
            hund.personIdHovedeier === personId
        ){
            return true;
        }
        return false;

    };

    const showDeleteIcon = () => {
        if (profilBilde !== null &&
            personId !== null &&
            hund !== null &&
            hund.personIdHovedeier === personId
        ){
            return true;
        }
        return false;
    };



    const favorittIkon = () => {
        if (favoritt) {
            return (
                <img className="icon favourite" src={icons.fav} alt="Fjern fra mine favoritter" />
            )
        }
        return (
            personId !== null && <img className="icon favourite" src={icons.favHollow} alt="Legg til mine favoritter" />
        )
    };

    const printIkon = (url) => {
        return (
            personId !== null && <a href={url} className="printer"><img className="icon printer" src={icons.printer} alt="Print" /></a>
        )

    };


    function getIdnummere() {
        let str = "";
        if (hund.idnummere.length > 0) {
            for(let i = 0; i < hund.idnummere.length; i++){
                str += hund.idnummere[i] + " ";
            }
        }
        return str.trim();
    };

    function updateStatus() {
        updateFavorittStatus(!favoritt);
    }

    const url = process.env.REACT_APP_HUNDEWEB_ENDPOINT + "/hdb/openPage/print/hundPrint_select.html?HUID=" + hund.hundId;
    return (
        <div className="dogweb-box">
            <div className={profilBilde != null ? "dogweb-card profil" : "dogweb-card"}>
                <div className="profilbilde">
                    { showUploadIcon() &&  <Uploadable action="uploadHundBilde" hundId={hund.hundId} reloadBilde={reloadBilde} appendFormData={appendFormData} /> }
                    { showDeleteIcon() &&  <button onClick={slettHundBilde} className="slet-knapp"><img alt="" className="icon slet" src={icons.slet} title="Slet billede" /></button> }
                    {
                        profilBilde != null
                        && <Bilde url={profilBilde.url}
                                  heroimage={true}/>
                    }

                </div>
                <div className="profildata">
                    <HundMetadata hund={hund}/>
                    <h3>{hund.navn} <span onClick={() => { updateStatus(); } }>{favorittIkon()}</span> {printIkon(url)}</h3>
                    <p><label>Race:</label> {hund.rase.navn} </p>
                    <p><label>FCI-Nummer</label> {hund.rase.fciNr}</p>
                    <p><label>Køn:</label>{ hund.kjoenn === 'T' ? 'Tæve' : 'Han' }</p>
                    <p><label>Farve:</label> {hund.farge} </p>
                    <p><label>Født:</label> {formatDate(hund.foedt)}
                        { hund.doed &&
                            <span className="dod"><img alt="" className="icon" src={icons.dod} /> {hund.doedDato !== null && <>{formatDate(hund.doedDato)}</>}</span>
                        }
                    </p>
                    <p><label>Reg.nr:</label> {hund.hundId}</p>
                    { hund.opprinneligHundId !== null &&
                        <p><label>TIDLIGERE Reg.nr:</label> {hund.opprinneligHundId}</p>
                    }
                    <p><label>ID:</label> {getIdnummere()}</p>
                    { hund.diverse !== null &&
                        <p><span style={{"color": "#FF0000"}}>{hund.diverse}</span></p>
                    }
                    { hund.stumphale &&
                        <p><label>Stumphale:</label> Ja</p>
                    }

                    <div className="dog-logos">
                        { hund.xregister && <img className='' src={xregister} alt=""/> }
                        { hund.anbefalingStambok && <img className='' src={avlsanbefaling} alt=""/> }
                        { hund.mentalbeskrivelseResultat && <img className='' src={mental} alt=""/> }
                        { hund.importert && <img className='' src={importert} alt=""/> }
                        { hund.oppdretterUtdannelse && <img className='' src={utdannelse} alt=""/> }
                        { hund.oppdretterMasterclass && <img className='' src={masterclass} alt=""/> }

                    </div>
                </div>
            </div>
        </div>
    );
};

export default Hund;

